module.exports = __webpack_public_path__ + "static/media/edit-icon.e6840f55.svg";